import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Register from './Components/Register';
import Login from './Components/Login';
import Homepage from './Components/Homepage';
import Profile from './Components/Profile';
import Products from './Components/Products';
import Cart from './Components/Cart';
import Checkout from './Components/Checkout';
import OrderSummary from './Components/OrderSummary';
import Wishlist from './Components/Wishlist';
import AdminPanel from './Components/AdminPanel';
import Sellernav from './Components/Sellernav';
import SellerPanel from './Components/SellerPanel';
import AddProducts from './Components/SellerPanel/AddProducts';
import ProductCatlog from './Components/SellerPanel/ProductCatlog';
import UpdateProduct from './Components/SellerPanel/UpdateProduct';
import AddSeller from './Components/AdminPanel/AddSeller';
import MyOrders from './Components/MyOrders';
import Orders from './Components/SellerPanel/Orders';
import Coupons from './Components/AdminPanel/Coupons';
import AddCoupons from './Components/AdminPanel/AddCoupons';
import RemoveCoupons from './Components/AdminPanel/RemoveCoupons';
import TotalProducts from './Components/AdminPanel/TotalProducts';
import AllOrders from './Components/AdminPanel/AllOrders';
import UserConfig from './Components/AdminPanel/UserConfig';
import RemoveSeller from './Components/AdminPanel/RemoveSeller';
import SearchResults from './Components/SearchResults';
import SalesReport from './Components/SellerPanel/SalesReport';
import Sales from './Components/SellerPanel/Sales';
import DeliveryReport from './Components/SellerPanel/DeliveryReport';
import AddHub from './Components/AdminPanel/AddHub';
import DistributionHubPanel from './Components/DistributionHubPanel';
import DeliveryBoyConfig from './Components/DeliveryHubPanel/DeliveryBoyConfig';
import AddDeliveryBoy from './Components/DeliveryHubPanel/AddDeliveryBoy';
import RemoveDeliveryBoy from './Components/DeliveryHubPanel/RemoveDeliveryBoy';
import HubOrders from './Components/DeliveryHubPanel/HubOrders';
import SellerConfig from './Components/AdminPanel/SellerConfig';
import DistributionHubConfig from './Components/AdminPanel/DistributionHubConfig';
import RemoveHub from './Components/AdminPanel/RemoveHub';
import DeliveryBoyPanel from './Components/DeliveryBoyPanel';
import DBOrders from './Components/DeliveryBoyPanel/DBOrders';
import HubOrderSummary from './Components/DeliveryHubPanel/HubOrderSummary';
import AllotDeliveryBoy from './Components/DeliveryHubPanel/AllotDeliveryBoy';
import ServerError from './Components/ServerError';
function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Homepage/>}/>
        <Route path='/Login' element={<Login/>}/>
        <Route path='/Register' element={<Register/>}/>
        <Route path='/Profile' element={<Profile/>}/>
        <Route path='/MyOrders' element={<MyOrders/>}/>
        <Route path='/Products' element={<Products/>}/>
        <Route path='/SearchResults' element={<SearchResults/>}/>
        <Route path='/Cart' element={<Cart/>}/>
        <Route path='/Checkout' element={<Checkout/>}/>
        <Route path='/OrderSummary' element={<OrderSummary/>}/>
        <Route path='/Wishlist' element={<Wishlist/>}/>
        <Route path='/AdminPanel' element={<AdminPanel/>}/>
        <Route path='/AdminPanel/UserConfig' element={<UserConfig/>}/>
        <Route path='/AdminPanel/UserConfig/SellerConfig' element={<SellerConfig/>}/>
        <Route path='/AdminPanel/UserConfig/SellerConfig/AddSeller' element={<AddSeller/>}/>
        <Route path='/AdminPanel/UserConfig/SellerConfig/RemoveSeller' element={<RemoveSeller/>}/>
        <Route path='/AdminPanel/UserConfig/DistributionHubConfig' element={<DistributionHubConfig/>}/>
        <Route path='/AdminPanel/UserConfig/DistributionHubConfig/AddHub' element={<AddHub/>}/>
        <Route path='/AdminPanel/UserConfig/DistributionHubConfig/RemoveHub' element={<RemoveHub/>}/>
        <Route path='/AdminPanel/Coupons' element={<Coupons/>}/>
        <Route path='/AdminPanel/Coupons/AddCoupons' element={<AddCoupons/>}/>
        <Route path='/AdminPanel/Coupons/RemoveCoupons' element={<RemoveCoupons/>}/>
        <Route path='/AdminPanel/ProductCatlog' element={<TotalProducts/>}/>
        <Route path='/AdminPanel/AllOrders' element={<AllOrders/>}/>
        <Route path="/SellerPanel" element={<SellerPanel/>}/>
        <Route path="/SellerPanel/AddProducts" element={<AddProducts/>}/>
        <Route path="/SellerPanel/ProductCatlog" element={<ProductCatlog/>}/>
        <Route path="/SellerPanel/UpdateStocks" element={<UpdateProduct/>}/>
        <Route path="/SellerPanel/SalesReports" element={<Orders/>}/>
        <Route path="/SellerPanel/SalesReport" element={<SalesReport/>}/>
        <Route path="/SellerPanel/SalesReport/Sales" element={<Sales/>}/>
        <Route path="/SellerPanel/SalesReport/Sales/DeliveryReport" element={<DeliveryReport/>}/>
        <Route path="/DistributionHubPanel" element={<DistributionHubPanel/>}/>
        <Route path="/DistributionHubPanel/HubOrders" element={<HubOrders/>}/>
        <Route path="/DistributionHubPanel/HubOrders/HubOrderSummary" element={<HubOrderSummary/>}/>
        <Route path="/DistributionHubPanel/HubOrders/HubOrderSummary/AllotDeliveryBoy" element={<AllotDeliveryBoy/>}/>
        <Route path="/DistributionHubPanel/DeliveryBoyConifg" element={<DeliveryBoyConfig/>}/>
        <Route path="/DistributionHubPanel/DeliveryBoyConfig/AddDeliveryBoy" element={<AddDeliveryBoy/>}/>
        <Route path="/DistributionHubPanel/DeliveryBoyConfig/RemoveDeliveryBoy" element={<RemoveDeliveryBoy/>}/>
        <Route path="/DeliveryBoyPanel" element={<DeliveryBoyPanel/>}/>
        <Route path="/DeliveryBoyPanel/Orders" element={<DBOrders/>}/>
        <Route path="/ServerError" element={<ServerError/>}/>
        
       </Routes>
    </Router>
  );
}
export default App;
